'use client';
import React, { FC } from 'react';

import { MuxVideo } from '@/components/ui/MuxVideo';
import { TypeFullVideoSectionFields } from '@/core/generated-types/TypeFullVideoSection';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TypeMuxVideoFields } from '@/core/generated-types';

export const MuxVideoSection: FC<TypeFullVideoSectionFields> = ({
  mediaDesktop,
  mediaMobile,
  autoplay = true,
}) => {
  const isDesktop = useIsDesktop();
  const media = isDesktop ? mediaDesktop : mediaMobile;
  const mediaFields = media?.fields as TypeMuxVideoFields;
  const playbackId =
    media && (media.fields as TypeMuxVideoFields)?.muxVideoUpload?.playbackId;

  if (!playbackId) return null;

  const props = {
    title: media.fields.entryName || '',
    playbackId,
    autoplay,
    controls: !mediaFields.hideControls,
  };

  return (
    <div className="w-full aspect-[9/16] lg:aspect-video h-full">
      <MuxVideo {...props} />
    </div>
  );
};

export default MuxVideoSection;
